module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image2-74aacadd585c29ac498f78c42c084b70.png";